const esriConfig = {
  version: '4.20',

  map: {
    fireflyBasemap: '9e557abc61ce41c9b8ec8b15800c20d3',
  },
  safeTopLayerIndex: 2, // Index to insert layers into at the end of map.allLayers array (currently Hansen Layer + 1)
  maxLayerTitleLength: 100,
};
const staging = {
  auditPolygonDownload: 'https://devfscintmaps.fsc.org/server/rest/services/AuditPolygonDownload/GPServer/FSC Audit Polygon Download',
  printService: `http://sampleserver6.arcgisonline.com/arcgis/rest/services/Utilities/PrintingTools/GPServer/Export%20Web%20Map%20Task`,
  portalResourcesURL: 'https://devfscintmaps.fsc.org/server/rest/services/Hosted/GIS_Portal_Resources/FeatureServer/0'
};

const production = {
  auditPolygonDownload: 'https://maps.fsc.org/server/rest/services/AuditPolygonDownload/GPServer/FSC Audit Polygon Download',
  printService: `http://sampleserver6.arcgisonline.com/arcgis/rest/services/Utilities/PrintingTools/GPServer/Export%20Web%20Map%20Task`,
  portalResourcesURL: 'https://maps.fsc.org/server/rest/services/Hosted/GIS_Portal_Resources_Modal/FeatureServer/0'
};


export const esri = process.env.REACT_APP_ENVIRONMENT === 'Production' ? {...esriConfig, ...production} : {...esriConfig, ...staging};